import script from "./HeadCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeadCard.vue?vue&type=script&lang=ts&setup=true"

import "./HeadCard.vue?vue&type=style&index=0&id=e9d7ed3e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d7ed3e"]])

export default __exports__